<template>
  <div class="app-window">
    <ion-header>
      <ion-toolbar>
        <ion-title>Evaluation : Your Details</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item v-for="qi in quizItems" v-bind:key="qi.order">
          <template v-if="qi.type === 'select-countries'">
            <quiz-item-select :quiz-item="qi" v-on:answer="qi._answer = $event"
                              v-bind:multi-select="true" v-bind:with-preference="true"></quiz-item-select>
          </template>
          <template v-else-if="qi.type === 'dob'">
            <quiz-item-dob :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-dob>
          </template>
          <template v-else>
            <quiz-item-select :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-select>
          </template>

        </ion-item>
          <ion-button  expand="block" v-on:click="proceed()">
            PROCEED
            <ion-icon :icon="chevronForwardOutline"></ion-icon>
          </ion-button>
      </ion-list>

    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-button slot="end" v-on:click="proceed()">
          PROCEED
          <ion-icon :icon="chevronForwardOutline"></ion-icon>
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonButton,
  IonIcon,
  IonItem,
  IonList,
  IonContent,
  // IonPage,
  isPlatform,
} from '@ionic/vue';
import {
  chevronForwardOutline
} from 'ionicons/icons';

import EoppService from "@/mixins/EoppService";
import QuizItemSelect from './QuizItemSelect.vue';
import router from "./Router";
import QuizItemDob from "@/enrol/QuizItemDob";
import MessageService from "@/mixins/MessageService";

export default {
  name: 'Quiz',
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonButton,
    IonIcon,
    IonItem,
    IonList,
    IonContent,
    // IonPage,
    QuizItemDob,
    QuizItemSelect
  },
  mixins: [
    EoppService,
    MessageService
  ],
  data() {
    return {
      chevronForwardOutline,
      quizItems: [],
      mirror: true
    };
  },
  mounted() {
    this.loadQuiz();
  },
  methods: {
    getAnswers: function () {
      const res = {};
      (this.quizItems || []).forEach(qi => {
        if (qi._answer) {
          switch (qi.type) {
            case 'dob' :
              res[qi.code] = qi._answer;
              break;
            case 'select-countries' :
              res[qi.code] = [];
              (qi._answer || []).forEach(c => {
                res[qi.code].push(c.name);
              });
              break;
            default :
              res[qi.code] = qi._answer.code;
              res[qi.code + '_des'] = qi._answer.name;
              break
          }
        }
      });
      return res;
    },
    proceed: async function () {
      let res = this.getAnswers();
      console.log(res);

      const count = Object.keys(res).length;

      console.log(res);

      if (!res.dob || res.dob.trim().length === 0) {
        this.toast('Warning', 'Please Provide your Date of Birth');
        return;
      }

      const d = new Date(res.dob);
      const minAge = this.quizItems.find(o => o.code === 'dob').minage || 16;

      d.setFullYear(d.getFullYear() + minAge);

      if (d.getFullYear() > new Date().getFullYear()) {
        this.toast('Warning', 'You must be at least ' + minAge + ' years old ');
        return;
      }


      if (!res.nationality || res.nationality.trim().length === 0) {
        this.toast('Warning', 'Please Provide your Current residence Country');
        return;
      }

      localStorage.setItem('eopp-quiz', JSON.stringify(this.quizItems));

      let valid = true;
      if (count < this.quizItems.length) {
        valid = await this.confirmAction(
            'Confirm ', 'You haven\'t provide all the information',
            ` It is important to have as much as information to find the best solution sor you. Please click on confirm if you want to continue`);
      }

      if (valid) {
        this.$store.commit('quizAnswers', res);
        await router.push({path: '/contacts'})
      }
    },
    loadQuiz: function () {
      // this.recaptchaV3Service.execute('quiz')
      //     .subscribe((token) => {
      this.getQuiz().then(res => {
        if (res && res.data) {
          res.data.sort((a, b) => {
            return a.order - b.order;
          });

          let order = 1;
          res.data.forEach(o => {
            o.order = order++;
          });

          this.setPrevAnswers(res.data);
        }
        // this.quiz = this.quizItems;

      });
      // });
    },
    setPrevAnswers: function (items) {
      let str = localStorage.getItem('eopp-results');
      if (str) {
        this.$store.commit('prevSignupInfo', JSON.parse(str));
      }

      str = localStorage.getItem('eopp-quiz');
      if (str) {
        // this.prevQuiz = JSON.parse(str);
        this.$store.commit('prevQuiz', JSON.parse(str));

        // items = items.filter( o => o.code === 'edu');

        items.forEach(item => {
          const prev = this.getPrevQuizItem(item.code);
          if (prev) {
            item._answer = prev._answer;
            // this.answer = this.quizItem.options.find(o => o.code === prev._answer.code);
          }
        });
        // this.quizItems = res.data;
      }

      this.quizItems = items;
    },
    isDesktop: function () {
      return isPlatform('desktop');
    },

  }
}
</script>
<style>


</style>
